import { convertToRaw } from 'draft-js';
import { convertFromHTML } from 'draft-convert';
import { ENTITY_TYPE } from 'draftail';
/**
 * Convert html string to draft raw
 * @param {string} value - The html string
 * @returns {unknown} - The draft raw
 */
export default (function (html) { return convertToRaw(convertFromHTML(importerConfig)(html)); });
/* Private */
var importerConfig = {
    htmlToEntity: function (nodeName, node, createEntity) {
        // a tags will become LINK entities, marked as mutable, with only the URL as data.
        if (nodeName === 'a') {
            return createEntity(ENTITY_TYPE.LINK, 'MUTABLE', { url: node.href });
        }
        if (nodeName === 'hr') {
            return createEntity(ENTITY_TYPE.HORIZONTAL_RULE, 'IMMUTABLE', {});
        }
        return null;
    },
    htmlToBlock: function (nodeName) {
        if (nodeName === 'hr') {
            // "atomic" blocks is how Draft.js structures block-level entities.
            return 'atomic';
        }
        return null;
    },
};
